"use strict";
export class TMSLoad {
  constructor(load) {
    this.load = load;
  }
}
